import { API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import {
  getToken,
  GET_PACKAGE_CREATION,
  getNetworkMenuId,
  GET_TOTAL_COUNT,
  GET_CLIENTLIST_NETWORK,
  GET_FACILITYCATEGORY_NETWORK,
  GET_ALLTESTCREATION_NETWORK,
  GET_PREPARATION_FOR_CHECKUP,
  GET_DIAGNOSTICS_DETAILS,
  GET_TEST_CREATION_DETAIL,
  GET_PARAMETER_CREATION_DETAILS,
  GET_SERVICE_CREATION_DETAIL,
} from "../../Utils/types";

export const getPackageCreationAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Package/GetAllPackages`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_PACKAGE_CREATION,
        res?.data?.results?.lstPackageDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PACKAGE_CREATION, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getClientListNetworkAction = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Package/GetClientListNetwork`;
  return HttpUtil.makePOST(
    url,
    {
      clientId: 0,
      clientName: "",
    },
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_CLIENTLIST_NETWORK, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_CLIENTLIST_NETWORK, [], dispatch);
    }
  });
};

export const getFacilityCategoryNetworkAction = (type) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Package/getFacilityCategoryNetwork?FacilityType=${type}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_FACILITYCATEGORY_NETWORK,
        type === "PACKAGE"
          ? [
              { facilityCategoryId: 0, facilityCategory: "Overall" },
              ...res?.data?.results,
            ]
          : [...res?.data?.results],
        dispatch
      );
    } else {
      getDispatch(GET_FACILITYCATEGORY_NETWORK, [], dispatch);
    }
  });
};

export const getAllTestsCreationAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Package/getAllTests`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_ALLTESTCREATION_NETWORK, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_ALLTESTCREATION_NETWORK, [], dispatch);
    }
  });
};
export const getPreparationForCheckupAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Package/GetPreparationForCheckupNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_PREPARATION_FOR_CHECKUP,
        [{ preparationForCheckup: "Create New +" }, ...res?.data?.results],
        dispatch
      );
    } else {
      getDispatch(GET_PREPARATION_FOR_CHECKUP, [], dispatch);
    }
  });
};

export const getExportPackageCreationAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Package/GetAllPackagesExportToExcelNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const getPackageCreationByIdAction = (id) => () => {
  const url = `${API_URL_WITHOUT_USER}/Package/GetPackageById?id=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};

export const addPackageCreationAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Package/AddUpdatePackage`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const activeInactivePackageAction = (id, booleanValue) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Package/ChangePackageActiveStatus?PackageId=${id}&IsActive=${booleanValue}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

//Diagnostics API
export const getDiagnosticCategoryAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Test/GetDiagnosticCategory`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_DIAGNOSTICS_DETAILS,
        res?.data?.results?.lstDiagCategory,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_DIAGNOSTICS_DETAILS, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const addDiagnosticAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/AddUpdateDiagnosticCategory`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};
export const AddUpdateServiceType = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/AddUpdateServiceTypeAsync`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const activeInactiveDiagnosticsAction =
  (id, booleanValue) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/Test/ChangeDiagnosticCategoryActiveStatus?DiagnosticCategoryId=${id}&IsActive=${booleanValue}`;
    return HttpUtil.makePOST(
      url,
      {},
      {
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

// Test Creation API
export const getTestCreationAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Test/GetTestDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_TEST_CREATION_DETAIL,
        res?.data?.results?.lstTestDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_TEST_CREATION_DETAIL, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetServiceTypeAction = (id) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Test/GetServiceTypeAsync?facilityId=${id}`;
  return HttpUtil.makeGET(url, {}, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_SERVICE_CREATION_DETAIL,
        res?.data?.results?.serviceTypeResultList,
        dispatch
      );
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_SERVICE_CREATION_DETAIL, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getTestCreationByIdAction = (id) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/GetTestById?testId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};

export const activeInactiveTestCreationAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Test/ChangeTestStatusNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const addTestCreationAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/AddUpdateTest`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};
export const addServiceCreationAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/AddUpdateServiceSKU`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

// Parameter Creation
export const getParameterCreationAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Test/GetMappedTestParameters`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_PARAMETER_CREATION_DETAILS,
        res?.data?.results?.testParameters,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.rowCount, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PARAMETER_CREATION_DETAILS, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const addParameterCreationAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Test/MapTestParameters`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};
